/**
 * 群组聊天列表
 * Bai.Zhiming
 * 2019-7-18
 */
angular.module("groupChartListModule", []).
directive("groupChartList", ['$q', '$timeout', 'imService', function($q, $timeout, imService) {
    return {
        restrict: 'E',
        replace: true,
        scope: false,
        templateUrl: "./IM/chatWindow/chartList/groupChartList/groupChartList_tpl.html",
        link(scope, $element, $attrs) {
            /*scope.$watch('item.LastMsg.MsgBody[0].MsgContent.Text', (newV, oldV) => {
                if (!newV) return;
                getGroupInfo(scope.item.ToAccount).then(resp => {
                    imService.getGroupHistory(scope.item.ToAccount, 20, 20).then(resp => {
                        let nickName = resp[resp.length-1].fromAccountNick;
                        let text = scope.item.LastMsg.MsgBody[0].MsgContent.Text;
                        $timeout(() => {
                            let TextProcessed = `${nickName}:${text}`;
                            scope.item.LastMsg.MsgBody[0].MsgContent.TextProcessed = TextProcessed;
                        });
                    });
                }, true);
            });*/
            /**
             * [getGroupInfo description] 获取组织信息
             * @param  {[type]} groupId [description] 组织ID
             * @return {[type]}                [description]
             */
            /*function getGroupInfo(groupId) {
                let deffer = $q.defer();
                var options = {
                    'GroupIdList': [
                        groupId
                    ],
                    'GroupBaseInfoFilter': [
                        'Type',
                        'Name',
                        'Introduction',
                        'Notification',
                        'FaceUrl',
                        'CreateTime',
                        'Owner_Account',
                        'LastInfoTime',
                        'LastMsgTime',
                        'NextMsgSeq',
                        'MemberNum',
                        'MaxMemberNum',
                        'ApplyJoinOption',
                        'ShutUpAllMember'
                    ],
                    'MemberInfoFilter': [
                        'Account',
                        'Role',
                        'JoinTime',
                        'LastSendMsgTime',
                        'ShutUpUntil'
                    ]
                };
                webim.getGroupInfo(options, resp => {
                    deffer.resolve(resp.GroupInfo[0]);
                }, error => {
                    console.log(error);
                    console.log('获取群组消息失败');
                    deffer.reject();
                });
                return deffer.promise;
            }*/
        }
    };
}])